import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Eyebrow, Reveal } from "./Reveal";
import { FAQS } from "./content";

export const Faq = () => (
  <section id="faq" className="mx-auto grid max-w-[1400px] gap-12 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-32" data-testid="faq-section">
    <Reveal className="lg:col-span-4">
      <Eyebrow>Parent questions</Eyebrow>
      <h2 className="mt-6 font-display text-5xl font-black uppercase leading-[0.92] text-bone sm:text-6xl">Asked by parents, every week.</h2>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-8">
      <Accordion type="single" collapsible className="border-t border-white/10">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-2xl font-bold uppercase leading-tight text-bone hover:text-lane hover:no-underline sm:text-3xl">
              {f.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 font-body text-base leading-relaxed text-mist">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
